module.exports = __webpack_public_path__ + "img/eingangsportal.6038b74e.jpg";